import { RumManager } from './rum';

interface VitalsReporter {
    onReport(name: string, value: unknown, context?: Record<string, unknown>): void;
}

interface VitalsReporterOptions {
    rum: RumManager;
    verbose?: boolean;
}

export const createVitalsReporter = (options: VitalsReporterOptions): VitalsReporter => {
    const { rum, verbose } = options;

    return {
        onReport(name, value, context) {
            if (typeof value === 'number') {
                rum.logEventFloat(name, value, context);
            }
            if (verbose) {
                // eslint-disable-next-line no-console
                console.info('[Vitals]', name, value, context);
            }
        },
    };
};
